export enum NodeEnv {
  Development = 'development',
  Production = 'production',
  Localhost = 'localhost',
}
